import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const EthereumAddresses = {
    TOKEN_RING: "0x9469d013805bffb7d3debe5e7839237e535ec483",
    TOKEN_KTON: "0x9f284e1337a815fe77d2ff4ae46544645b20c5ff",
    TOKEN_WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    ELEMENT_GOLD: "0x358dba28848cca268ba8a76b65e5b3ef9ef92238",
    ELEMENT_WOOD: "0xd4b784ae5c12153d11ca55853d832d2a2d514a08",
    ELEMENT_WATER: "0x19e22a73a046f19ecb51a46ace4ca7a4bb7c20c6",
    ELEMENT_FIRE: "0x8469a695d70033ecd170c82be1253842162aa77e",
    ELEMENT_SOIL: "0x1320994fa466e19f17b143995999c7275eae50e1",
    GOLD_RUSH_RAFFLE: "0x56746a8099a7e6D962802A23e01FeDdc1282cDAe",
    PVETEAM_PROXY: "",
    MATERIAL_PROXY: "",
    MATERIALTAKEBACK_PROXY: "",
    CRAFTBASE_PROXY: "",
    LAND_CLOCK_AUCTION: "0xf4f5da5d5141f73998bb9c2ef548bf47104e9d8f",
    APOSTLE_CLOCK_AUCTION: "0xa665271c365f9d9a149866574a5b047dd9e3d31b",
    SIRING_CLOCK_AUCTION: "0xe0a0489d93aeb831a04e8b631ebd9827a4db4a58",
    APOSTLE_BASE: "0x7469966be391e8fe5e85ab972819560c7c3d6e4c",
    LAND_RESOURCE: "0xa9203f3303126243C8D181006ab03B2474E3C084",
    TOKEN_USE: "0xa70abeaca1d6bba0f511758a0d66b7f59fd3f166",
    OBJECTOWNERSHIP: "0x14a4123da9ad21b2215dc0ab6984ec1e89842c6d",
    SETTINGSREGISTRY: "0x6B0940772516B69088904564A56d09CFe6Bb3D85",
    POINTS_REWARD_POOL: "0xa4db07460c7473ef3aaf2c26da46b00a4d986d72",
    TOKEN_USER_POINTS: "0x335e07b1465d1158b8300c675ee8903c65981266",
    FURNACE_TREASURE: "0xc7D7E731d6bf9182701096adCd5bba3bb0CF76fc",
    FURNACE_ITEM_BASE: "0xfd9C2B86f71C1484Bc51F97Bd9E323cB2Cd475C9",
    FURNACE_TAKEBACK: "0x8d7af9d2310016712b8f269df266f957cb12a27b",
    UNISWAP_EXCHANGE: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
    STAKINGREWARDSFACTORY: "",
    GOLDRAFFLEPOOL_PROXY: "",
    WOODRAFFLEPOOL_PROXY: "",
    WATERRAFFLEPOOL_PROXY: "",
    FIRERAFFLEPOOL_PROXY: "",
    SOILRAFFLEPOOL_PROXY: "",
};
export const EthereumTokens = {
    RING: new Token(ChainId.ROPSTEN, EthereumAddresses.TOKEN_RING, 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.ROPSTEN, EthereumAddresses.TOKEN_KTON, 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.ROPSTEN, EthereumAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.ROPSTEN, EthereumAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.ROPSTEN, EthereumAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.ROPSTEN, EthereumAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.ROPSTEN, EthereumAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.ETHEREUM],
};
